import BaseActivityService from '@/Modules/Activity/BaseActivityService.js'

export default class EntityActivityService extends BaseActivityService {
  static resource = 'entities'
}

